import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppLoaderDirective } from './app-loader.directive';
import { ControlValidationDirective } from './control-validation.directive';
import { CreditCardFormatDirective } from './credit-card/credit-card-format.directive';
import { CvcFormatDirective } from './credit-card/cvc-format.directive';
import { ExpiryFormatDirective } from './credit-card/expiry-format.directive';
import { CustomMatMenuDirective } from './custom-mat-menu.directive';
import { DebounceTimeDirective } from './debounce-time.directive';
import { DecimalLimitDirective } from './decimal-limit.directive';
import { FormGroupValidationDirective } from './form-group-validation.directive';
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { InvalidNumberInputDirective } from './invalid-number-input';
import { KeyPressLineItemsDirective } from './key-press-line-items.directive';
import { LumFocusHighlightDirective } from './lum-focus-highlight.directive';
import { NoEmptySpacesOnlyDirective } from './no-empty-spaces-only.directive';
import { PreventScrollDirective } from './prevent-scroll.directive';
import { RfqThumbnailUrlDirective } from './rfq-thumbnail-url.directive';
import { TableAnimateRowDirective } from './table-animate-row.directive';
import { TextOnlyDirective } from './text-only.directive';

const angularModules = [FormsModule, ReactiveFormsModule, CommonModule];

const directives = [
  AppLoaderDirective,
  DebounceTimeDirective,
  CustomMatMenuDirective,
  DecimalLimitDirective,
  InfiniteScrollDirective,
  ControlValidationDirective,
  FormGroupValidationDirective,
  PreventScrollDirective,
  KeyPressLineItemsDirective,
  TableAnimateRowDirective,
  RfqThumbnailUrlDirective,
  NoEmptySpacesOnlyDirective,
  CvcFormatDirective,
  CreditCardFormatDirective,
  ExpiryFormatDirective,
  InvalidNumberInputDirective,
  LumFocusHighlightDirective,
  TextOnlyDirective
];

@NgModule({
  declarations: [...directives],
  exports: [...directives],
  imports: [...angularModules],
})
export class DirectiveModule {}
